import { firestore } from '../lib/db';
import { cleanFirebaseId, reviewsLimit, cleanGUID } from '../lib/utils';
import { Timestamp, collection, query, where, arrayRemove, arrayUnion, deleteField, getDoc, doc, setDoc } from "firebase/firestore/lite";

import {
    LOADING_REVIEW_REPLIES, FETCH_REVIEW_REPLIES, ADD_REVIEW_REPLY, EDIT_REVIEW_REPLY, REPORT_REVIEW_REPLY, UNREPORT_REVIEW_REPLY, SET_HAS_REPLIES
} from './types';

export const fetchReviewReplies = (review) => async (dispatch, getState) => {

    const prevFetchedReviewReplies = getState().reviewRepliesState && getState().reviewRepliesState[`${review.id}`];

    if (!prevFetchedReviewReplies) {
        dispatch({
            type: LOADING_REVIEW_REPLIES,
            payload: { loadingReviewReplies: true }
        });

        return getDoc(doc(firestore, `reviews/${review.id}/replies`, 'details'))
            .then((doc) => {
                if (doc.exists()) {
                    console.log("Document data:", doc.data());
                    // let review = {};
                    const reviewReplies = doc.data() || {};
                    dispatch({
                        type: FETCH_REVIEW_REPLIES,
                        payload: { [`${review.id}`]: reviewReplies }
                    });
                } else {
                    console.log("No such document!");
                    // dispatch({
                    //     type: FETCH_REVIEW_ERROR,
                    //     error: true
                    // })
                }

                dispatch({
                    type: LOADING_REVIEW_REPLIES,
                    payload: { loadingReviewReplies: false }
                });
            })
            .catch((err) => {
                dispatch({
                    type: LOADING_REVIEW_REPLIES,
                    payload: { loadingReviewReplies: false }
                });
                // reject(err);
                throw err;
            })
    }
};

// export const replyReview = (review, replyComment, userDetails) => async (dispatch) => {
//     const replyInfo = {};
//     replyInfo['reviewId'] = review.id;
//     replyInfo['userUIDs'] = firebase.firestore.FieldValue.arrayUnion(userDetails.uid);
//     let now = new Date();
//     let nowInMillis = now.getTime();
//     replyInfo['comments'] = {
//         [nowInMillis]: {
//             'postedTime': nowInMillis, 'comment': replyComment,
//             user: { 'uid': userDetails.uid, 'name': userDetails.name }
//         }
//     };

//     dispatch({
//         type: ADD_REVIEW_REPLY,
//         reviewId: review.id,
//         replyInfo: replyInfo
//     })
//     console.dir(replyInfo);

//     if (!review.hasReplies) {
//         firebase.firestore().collection('reviews').doc(review.id)
//             .set({ hasReplies: true }, { merge: true })
//             .then(() => {
//                 console.log('success');
//             })
//             .catch((err) => {
//                 // reject(err);
//                 throw err;
//             })
//     }

//     return firebase.firestore().collection('reviews').doc(review.id).collection('replies').doc('details')
//         .set(replyInfo, { merge: true })
//         .then(() => {
//             console.log('success');
//         })
//         .catch((err) => {
//             // reject(err);
//             throw err;
//         })
// };

export const replyReviewComment = (review, parentCommentId, replyComment, userDetails) => async (dispatch) => {
    console.dir(review);
    const replyInfo = {};
    replyInfo['reviewId'] = review.id;
    replyInfo['userUIDs'] = arrayUnion(userDetails.uid);
    let now = new Date();
    let nowInMillis = now.getTime();
    let finalCommentId;
    if (!parentCommentId) {
        finalCommentId = `${nowInMillis}`;
    } else {
        finalCommentId = `${parentCommentId}-${nowInMillis}`;
    }
    replyInfo['comments'] = {
        [finalCommentId]: {
            'postedTime': nowInMillis, 'comment': replyComment,
            user: { 'id': userDetails.uid, 'name': userDetails.name }
        }
    };

    dispatch({
        type: ADD_REVIEW_REPLY,
        reviewId: review.id,
        replyInfo: replyInfo
    })

    if (!review.hasReplies) {
        // add dispatch with hasReplies to redux
        dispatch({
            type: SET_HAS_REPLIES,
            reviewId: review.id
        })
        //*** moved to cloud function trigger */
        // firebase.firestore().collection('reviews').doc(review.id)
        //     .set({ hasReplies: true }, { merge: true })
        //     .then(() => {
        //         console.log('success');
        //     })
        //     .catch((err) => {
        //         // reject(err);
        //         throw err;
        //     })
    }

    return setDoc(doc(firestore, `reviews/${review.id}/replies`, 'details'), replyInfo, { merge: true })
        .then(() => {
            console.log('success');
        })
        .catch((err) => {
            // reject(err);
            throw err;
        })
};

export const editReviewComment = (review, commentId, replyComment, userDetails) => async (dispatch) => {
    const replyInfo = {};
    // replyInfo['reviewId'] = review.id;
    // replyInfo['userUIDs'] = firebase.firestore.FieldValue.arrayUnion(userDetails.uid);
    let now = new Date();
    let nowInMillis = now.getTime();

    replyInfo['comments'] = {
        [commentId]: {
            'modifiedTime': nowInMillis, 'comment': replyComment,
        }
    };

    dispatch({
        type: EDIT_REVIEW_REPLY,
        reviewId: review.id,
        commentId: commentId,
        commentInfo: replyInfo['comments'][commentId]
    })

    return setDoc(doc(firestore, `reviews/${review.id}/replies`, 'details'), replyInfo, { merge: true })
        .then(() => {
            console.log('success');
        })
        .catch((err) => {
            // reject(err);
            throw err;
        })
};

export const deleteReviewComment = (review, commentId, userDetails) => async (dispatch) => {
    const replyInfo = {};
    // replyInfo['reviewId'] = review.id;
    replyInfo['userUIDs'] = arrayRemove(userDetails.uid);
    let now = new Date();
    let nowInMillis = now.getTime();
    replyInfo['comments'] = {
        [`${commentId}`]: {
            'deletedTime': nowInMillis, 'comment': deleteField(),
            user: deleteField()
        }
    };

    dispatch({
        type: ADD_REVIEW_REPLY,
        reviewId: review.id,
        replyInfo: replyInfo
    })

    return setDoc(doc(firestore, `reviews/${review.id}/replies`, 'details'), replyInfo, { merge: true })
        .then(() => {
            console.log('success');
        })
        .catch((err) => {
            // reject(err);
            throw err;
        })
};

export const toggleReportReviewComment = (review, commentId, userDetails, type = 'report') => async (dispatch) => {
    const replyInfo = {};
    // replyInfo['reviewId'] = review.id;
    // replyInfo['userUIDs'] = firebase.firestore.FieldValue.arrayUnion(userDetails.uid);

    if (type === 'report') {
        dispatch({
            type: REPORT_REVIEW_REPLY,
            reviewId: review.id,
            commentId: commentId,
            userUID: userDetails.uid
        })
        replyInfo['comments'] = {
            [commentId]: {
                reportedArray: arrayUnion(userDetails.uid)
            }
        };
    } else {
        dispatch({
            type: UNREPORT_REVIEW_REPLY,
            reviewId: review.id,
            commentId: commentId,
            userUID: userDetails.uid
        })
        replyInfo['comments'] = {
            [commentId]: {
                reportedArray: arrayRemove(userDetails.uid)
            }
        };
    }

    return setDoc(doc(firestore, `reviews/${review.id}/replies`, 'details'), replyInfo, { merge: true })
        .then(() => {
            console.log('success');
        })
        .catch((err) => {
            // reject(err);
            throw err;
        })
};